import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/theme/src/templates/single-post.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`This page has details of text formatting used in Arabic Blog with examples.`}</p>
    <p><strong parentName="p" {...{
        "className": "firstword"
      }}>{`First Word`}</strong></p>
    <br />
    <p><strong parentName="p" {...{
        "className": "word"
      }}>{`Word`}</strong>{` <- This has to be deprecated`}</p>
    <h2>{`H2 Tag`}</h2>
    <p><strong parentName="p" {...{
        "className": "heading1"
      }}>{`Heading 1 Welcome to code blog. Enjoy the content. This is in the demo Post`}</strong><br parentName="p"></br>{`
`}<strong parentName="p" {...{
        "className": "heading2"
      }}>{`Heading 2 Welcome to code blog. Enjoy the content. This is third Post`}</strong></p>
    <h3>{`H3 Tag`}</h3>
    <p><strong parentName="p" {...{
        "className": "heading1"
      }}>{`Heading 1 Welcome to code blog. Enjoy the content. This is third Post`}</strong><br parentName="p"></br>{`
`}<strong parentName="p" {...{
        "className": "heading2"
      }}>{`Heading 2 Welcome to code blog. Enjoy the content. This is third Post`}</strong></p>
    <br />
    <p><strong parentName="p" {...{
        "className": "exception"
      }}>{`Exception Welcome to code blog. Enjoy the content. This is third Post`}</strong></p>
    <br />
    <p><strong parentName="p" {...{
        "className": "bg-yellow"
      }}>{`Yellow background Welcome to code blog.`}</strong></p>
    <br />
    <p><strong parentName="p" {...{
        "className": "bg-cyan"
      }}>{`Cyan background Welcome to code blog.`}</strong></p>
    <br />
    <p><strong parentName="p" {...{
        "className": "bg-green"
      }}>{`Green background Welcome to code blog.`}</strong></p>
    <br />
    <blockquote>
      <p parentName="blockquote">{`blockquote: Welcome to code blog.`}</p>
    </blockquote>
    <br />
    <p><code parentName="p" {...{
        "className": "language-text"
      }}>{`Code: Welcome to code blog. Enjoy the content. This is third Post`}</code></p>
    <br />
    <blockquote>
      <p parentName="blockquote"><strong parentName="p" {...{
          "className": "arabic irab"
        }}>{`عاصياً`}</strong>{`
منادى `}<strong parentName="p" {...{
          "className": "irabhighlight"
        }}>{`منصوب`}</strong>{` وعلامة نصبه الفتحة`}</p>
    </blockquote>
    <br />
    <blockquote>
      <p parentName="blockquote"><strong parentName="p" {...{
          "className": "arabic irab"
        }}>{`زيد`}</strong>{`
منادى مبني على الضم في محل نصب`}</p>
    </blockquote>
    <br />
    <blockquote>
      <p parentName="blockquote">{`What is this`}</p>
      <ul parentName="blockquote">
        <li parentName="ul">{`This is list`}</li>
        <li parentName="ul">{`this is item 2`}</li>
      </ul>
    </blockquote>
    <br />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Singular`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Dual`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Plural`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Third Person (Male)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبَ`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبَا`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبُوا`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Third Person (Female)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبَتْ`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبَتَا`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبْنَ`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Second Person (Male)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبْتَ`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبْتُمَا`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبْتُمْ`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Second Person (Female)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبْتِ`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبْتُمَا`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبْتُنَّ`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`First Person`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبْتُ`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبْنَا`}</td>
        </tr>
      </tbody>
    </table>
    <br />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}></th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Singular`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Dual`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Plural`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Third Person (Male)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبَ`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبَا`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبُوا`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Third Person (Female)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبَتْ`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبَتَا`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبْنَ`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Second Person (Male)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبْتَ`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبْتُمَا`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبْتُمْ`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Second Person (Female)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبْتِ`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبْتُمَا`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`كَتَبْتُنَّ`}</td>
        </tr>
      </tbody>
    </table>
    <br />
    <h2>{`Code Blocks`}</h2>
    <h3>{`Java`}</h3>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "java"
    }}><pre parentName="div" {...{
        "className": "language-java"
      }}><code parentName="pre" {...{
          "className": "language-java"
        }}><span parentName="code" {...{
            "className": "token annotation punctuation"
          }}>{`@Configuration`}</span>{`
`}<span parentName="code" {...{
            "className": "token annotation punctuation"
          }}>{`@EnableAerospikeRepositories`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`basePackages `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"in.kamranali.aerospike.aerospike.repositories"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token annotation punctuation"
          }}>{`@EnableTransactionManagement`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`public`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`class`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`AerospikeConfig`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`

    `}<span parentName="code" {...{
            "className": "token annotation punctuation"
          }}>{`@Bean`}</span>{`
    `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`AerospikeTemplate`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`aerospikeTemplate`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
        `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`new`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`AerospikeTemplate`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`aerospikeClient`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"test"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{` `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// test is namespace`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

    `}<span parentName="code" {...{
            "className": "token annotation punctuation"
          }}>{`@Bean`}</span>{`
    `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`AerospikeClient`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`aerospikeClient`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`

        `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`ClientPolicy`}</span>{` clientPolicy `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`new`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`ClientPolicy`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
        clientPolicy`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`failIfNotConnected `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token boolean"
          }}>{`true`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
        `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`new`}</span>{` `}<span parentName="code" {...{
            "className": "token class-name"
          }}>{`AerospikeClient`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`clientPolicy`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`"localhost"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`3000`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`;`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "py"
    }}><pre parentName="div" {...{
        "className": "language-py"
      }}><code parentName="pre" {...{
          "className": "language-py"
        }}><span parentName="code" {...{
            "className": "token operator"
          }}>{`//`}</span>{` Spark Session Interface `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`in`}</span>{` spark `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2.0`}</span>{`
val spark `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` SparkSession`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`builder
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`appName`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"SalaryPredictionDF"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`master`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"local[*]"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`//`}</span>{` using `}<span parentName="code" {...{
            "className": "token builtin"
          }}>{`all`}</span>{` cores of CPU
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`getOrCreate`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

val inputLines `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` spark`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`sparkContext`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`textFile`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`"./src/main/resources/salary_data.txt"`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "650px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "88.95705521472392%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAACXBIWXMAAAsSAAALEgHS3X78AAACSklEQVQ4y5VU/0tTURR//4j/RL/0kz9FRlH0gyBUFElWECUlQSVk38AIC1pfIKUotfI5qbkFa05Xc5pjmm0ybW1zbuqY6FSWT6eb771P9958j/fm29QDh3fvPfed8/mcc+7hsCWyLDOlIkkyREliStdsL0qGqvyjfDkUiGLYi2idclp0imEikkbfjzjcvmn8DM4hFFuEayiBr/0xpg5PDHbydQ5MQVjN6Rhy2iiUGhXTuxFUnOVx9HwX9le24kiNGWXlL3H4XCcqqnkcqu7EQWI/dqEL8WRGTZNKWYtwhUQcHkshEJpnF+49H2ROT9XZdqSsyyFNMJXUvICHr7x48sbH9rceu7Hv+FtcvO34j8Qgx9scKnApsrvPBtBg8uBG03d88yZg7Yug8vJnnLhqValpGRlWWdxy6PUn0fDUA1PrCA6c6cDJa1ZEE8uoqbejqrZbRViqEzhtlOx6Hm2WIFr4AG42uXHpTg+C4QXmsBBhsRbjtIbVtRypII/fk4t41OLF6etfIJCzK/edqH3Qq+baiKohwvWNTdSTIkTiS6zXLL1hdv6ifRSvzQG2zufF0gh1DR1N46NtAoOjs2y/lMmihzQvRaxIfDaDHHFa0qHWOLcgYHJ6ma0/Of7AbA+xQO3d4/hAgtG8vreOFy0QV/gWtTJGmruZ96O5w09SMAXP8AyGfiVZgMKBso2yokqDU6o2V5TQTWNF2MBuhwhndIk+v7pGF3yk0ZXzTVHSjbSiCI0crmXzsDjDmEn91T18eYem3tU83Ot8/Ad6yTuxssceaQAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "aTech Guide",
          "title": "aTech Guide",
          "src": "/static/fa456c3a5ae9df98d271774f08cce41f/a6d36/atech-guide.png",
          "srcSet": ["/static/fa456c3a5ae9df98d271774f08cce41f/222b7/atech-guide.png 163w", "/static/fa456c3a5ae9df98d271774f08cce41f/ff46a/atech-guide.png 325w", "/static/fa456c3a5ae9df98d271774f08cce41f/a6d36/atech-guide.png 650w", "/static/fa456c3a5ae9df98d271774f08cce41f/1cfc2/atech-guide.png 900w"],
          "sizes": "(max-width: 650px) 100vw, 650px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      